var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast",class:_vm.color},[_c('button',{staticClass:"btn btn-clear float-right",on:{"click":function($event){return _vm.$emit('closeMessage')}}}),_vm._t("default",[_vm._v("Message Here")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }